import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import _ from 'lodash'
import dispatchSelector from 'reduxModules/menuItem/dispatchers'
import stateSelector from 'reduxModules/menuItem/selectors'
import './styles.css'

function MenuItem({
  title,
  options,
  show,
  showMenuItem,
  hideMenuItem,
  isLibrarySubscriber,
  hide,
  activeSection,
  url
}) {
  if (_.includes(hide, 'isLibrarySubscriber') && isLibrarySubscriber)
    return null

  return (
    <li
      className={`menu-item ${show ? 'active' : ''}`}
      onMouseEnter={showMenuItem}
      onMouseLeave={hideMenuItem}
    >
      <div
        className={`item item--${title} ${
          title.toLowerCase() === activeSection ? 'active' : ''
        }`}
      >
        {!url ? (
          <button
            type="button"
            onClick={() => (show ? hideMenuItem() : showMenuItem())}
            className="menu-button"
          >
            {title}
          </button>
        ) : (
          <Link to={url} tabIndex="0">
            {title}
          </Link>
        )}
      </div>

      {show && options.length > 0 && (
        <div className="submenu">
          <ul>
            {options.map((option) => (
              <li key={option.title}>
                {!option.isExternal ? (
                  <Link
                    to={option.url}
                    tabIndex="0"
                    onClick={() => {
                      hideMenuItem()
                    }}
                  >
                    {option.title}
                  </Link>
                ) : (
                  <a
                    href={option.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    tabIndex="0"
                    onClick={() => {
                      hideMenuItem()
                    }}
                  >
                    {option.title}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  )
}

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  showMenuItem: PropTypes.func.isRequired,
  hideMenuItem: PropTypes.func.isRequired,
  isLibrarySubscriber: PropTypes.bool,
  hide: PropTypes.arrayOf(PropTypes.string),
  activeSection: PropTypes.string,
  url: PropTypes.string
}

MenuItem.defaultProps = {
  title: '',
  options: [],
  show: false,
  isLibrarySubscriber: false,
  hide: [],
  activeSection: '',
  url: null
}

export default connect(stateSelector, dispatchSelector)(MenuItem)
